<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Para {{data[0]}}</h4>
    <button mat-button mat-dialog-close cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p mat-dialog-content class="dialog-content" [innerHtml]="data[1]"></p>
  <hr class="solid" />

  <div mat-dialog-actions>
    <div>
      <button mat-button mat-dialog-close class="button-close">Close</button>
    </div>
  </div>
</div>
